import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onKeydown"]
const _hoisted_2 = {
  class: "spform__head",
  "data-tour": "admin-product-summary"
}
const _hoisted_3 = { class: "spform__head-top" }
const _hoisted_4 = { class: "spform__title-row" }
const _hoisted_5 = { class: "spform__meta-badges" }
const _hoisted_6 = {
  key: 0,
  class: "spform__code-badge"
}
const _hoisted_7 = {
  key: 2,
  class: "aedit-modal__store-badge"
}
const _hoisted_8 = { class: "spform__head-actions" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "spform__loading"
}
const _hoisted_13 = { class: "spform__main" }
const _hoisted_14 = {
  key: 0,
  class: "aedit-modal__queue",
  "data-tour": "admin-product-queue-nav"
}
const _hoisted_15 = { class: "aedit-modal__queue-label" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "aedit-modal__queue-nav" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  class: "aedit-modal__ops",
  "data-tour": "admin-product-ops"
}
const _hoisted_21 = { class: "aedit-modal__ops-block" }
const _hoisted_22 = { class: "aedit-modal__ops-block" }
const _hoisted_23 = ["value", "disabled"]
const _hoisted_24 = {
  key: 0,
  class: "aedit-modal__link-list"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["value", "disabled"]
const _hoisted_27 = {
  key: 1,
  class: "aedit-modal__link-list"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  class: "spform__foot",
  "data-tour": "admin-product-actions"
}
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "spform__foot-end" }
const _hoisted_32 = ["onKeydown"]
const _hoisted_33 = { class: "spform__actions" }
const _hoisted_34 = ["open"]
const _hoisted_35 = { class: "aedit-modal__reject-panel" }
const _hoisted_36 = {
  class: "aedit-modal__templates",
  role: "group",
  "aria-label": "반려 사유 템플릿"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "aedit-hist__head" }
const _hoisted_42 = { class: "aedit-hist__body" }
const _hoisted_43 = {
  key: 0,
  class: "spform__alert spform__alert--warn"
}
const _hoisted_44 = {
  key: 1,
  class: "aedit-modal__timeline"
}
const _hoisted_45 = { class: "aedit-modal__timeline-meta" }
const _hoisted_46 = { class: "aedit-modal__timeline-who" }
const _hoisted_47 = {
  key: 0,
  class: "aedit-modal__timeline-memo"
}
const _hoisted_48 = {
  key: 1,
  class: "aedit-modal__timeline-empty"
}
const _hoisted_49 = {
  key: 2,
  class: "aedit-modal__request-empty"
}
const _hoisted_50 = {
  key: 3,
  class: "aedit-modal__history-more"
}
const _hoisted_51 = { class: "aedit-modal__logs" }
const _hoisted_52 = { class: "aedit-hist__foot" }
const _hoisted_53 = {
  key: 3,
  class: "aedit-busy",
  role: "status",
  "aria-live": "polite",
  "aria-busy": "true"
}
const _hoisted_54 = { class: "aedit-busy__icon" }

import { computed, nextTick, onMounted, onUnmounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import ProductRegisterSheet from '@/components/manage/ProductRegisterSheet.vue'
import ProductStockHistoryModal from '@/components/manage/ProductStockHistoryModal.vue'
import SellerProductPreview from '@/components/seller/SellerProductPreview.vue'
import { useAdminProducts } from '@/composables/useAdminProducts'
import { confirmDialog } from '@/composables/useConfirmDialog'
import {
  approveAdminProduct,
  fetchAdminProduct,
  fetchAdminProducts,
  rejectAdminProduct,
  saveAdminProduct,
  saveAdminProductRelated,
  setAdminProductStatus,
  uploadAdminImages,
} from '@/api/admin'
import { MALL_PRODUCT_STATUS_LABEL, type MallProductStatus, type ServerMallProduct } from '@/api/mallProduct'
import { SELLER_CATEGORIES } from '@/constants/sellerData'
import {
  PRODUCT_EDIT_SURFACES,
  REJECT_REASON_TEMPLATES,
  createProductForm,
  focusTargetFromPreviewZone,
  hydrateProductForm,
  productChecklist,
  productIssues,
  productProblems,
  sectionDoneMap,
  surfaceDef,
  surfaceFromPreviewZone,
  surfaceFromSection,
  previewModeForZone,
  previewZoneVisibleOn,
  toPreviewProduct,
  toProductPayload,
  type ProductEditSurface,
  type ProductPreviewMode,
  type ProductPreviewZone,
} from '@/constants/productEditor'
import {
  loadRequestedProductQueue,
  saveRequestedProductQueue,
} from '@/utils/adminProductQueue'
import { useSameDayCutoffText } from '@/composables/useContentSnippets'
import { formatShippingChargeLabel } from '@/utils/mallSell'
import { scrollWhenReady } from '@/utils/scrollIntoContainer'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminProductEditPage',
  setup(__props) {

const LOG_LABEL: Record<string, string> = {
  REQUEST: '검수 요청',
  APPROVE: '승인',
  REJECT: '반려',
  EDIT: '수정',
  HIDE: '숨김',
}

const REVIEW_ACTIONS = new Set(['REQUEST', 'APPROVE', 'REJECT'])

const STATUS_TONE: Record<MallProductStatus, string> = {
  DRAFT: 'sui-badge--gray',
  REQUESTED: 'sui-badge--violet',
  SELLING: 'sui-badge--green',
  SOLDOUT: 'sui-badge--amber',
  HIDDEN: 'sui-badge--gray',
  REJECTED: 'sui-badge--red',
}

const route = useRoute()
const router = useRouter()
const { notify, load } = useAdminProducts()

const code = computed(() => String(route.params.code ?? ''))
const titleId = `aedit-title-${Math.random().toString(36).slice(2, 7)}`
const historyTitleId = `aedit-history-${Math.random().toString(36).slice(2, 7)}`
const dialogEl = ref<HTMLElement | null>(null)
const historyEl = ref<HTMLElement | null>(null)
const historyOpen = ref(false)
const screenLock = ref(false)
const screenLockText = ref('')

const product = ref<ServerMallProduct | null>(null)
const loading = ref(true)
const saving = ref(false)
const showPreview = ref(false)
const stockHistoryOpen = ref(false)
const workMode = ref<'wizard' | 'editor'>('wizard')
const wizardSeed = ref('')
const wizardRef = ref<{ resetFromForm: (asReview?: boolean) => void } | null>(null)
const editSurface = ref<ProductEditSurface>('product')
const previewMode = ref<ProductPreviewMode>('card')
const previewZone = ref<ProductPreviewZone | ''>('')
const previewTabPulse = ref<ProductPreviewMode | ''>('')
let previewTabPulseTimer: ReturnType<typeof setTimeout> | undefined
const rejectReason = ref('')
const rejectTemplates = REJECT_REASON_TEMPLATES
const queueCodes = ref<string[]>([])
const editorRef = ref<{
  focusFirstIncomplete: () => void
  focusSection: (section: string, fieldSuffix?: string) => void
  focusByZone: (zone: ProductPreviewZone | '') => void
} | null>(null)
const adminMemo = ref('')
const relatedCodes = ref<string[]>([])
const substituteCodes = ref<string[]>([])
const relatedCandidates = ref<Array<{ code: string; name: string }>>([])
const initialFormSnapshot = ref('')

const form = reactive(
  createProductForm({ category: SELLER_CATEGORIES[0], shippingFee: 3000, freeShipOver: 0 }),
)

const storeShipping = computed(() => ({
  returnFee: Math.max(0, Number(product.value?.storeReturnFee) || 0),
  cutoff: product.value?.storeCutoff || '14:00',
  returnPolicy:
    product.value?.storeReturnPolicy ||
    '당일 출고 마감 · 교환 · 반품 기준은 판매업체가 안내한 정책을 따릅니다.\n상품 하자 · 오배송 시 수령 후 판매업체 안내에 따라 교환 · 반품이 가능합니다.\n단순 변심 반품은 판매업체가 안내한 반품 배송비가 부과될 수 있습니다.',
}))

const canToggleSaleStatus = computed(() => {
  const status = product.value?.status
  return status === 'SELLING' || status === 'SOLDOUT' || status === 'HIDDEN'
})

const stockLocked = computed(() => canToggleSaleStatus.value)

function onStockLedgerUpdated(payload: { code: string; stock: number; status?: string }) {
  form.stock = payload.stock
  if (product.value) {
    product.value.stock = payload.stock
    if (payload.status) product.value.status = payload.status as MallProductStatus
  }
  notify(`재고 ${payload.stock.toLocaleString('ko-KR')}개로 반영했습니다.`)
}

function formSnapshot(): string {
  return JSON.stringify({
    form,
    adminMemo: adminMemo.value,
    relatedCodes: relatedCodes.value,
    substituteCodes: substituteCodes.value,
  })
}

function markFormClean() {
  initialFormSnapshot.value = formSnapshot()
}

const dirty = computed(() => initialFormSnapshot.value !== formSnapshot())

function labelOf(rowCode: string): string {
  const found = relatedCandidates.value.find((row) => row.code === rowCode)
  return found?.name || rowCode
}

const relatedRows = computed(() =>
  relatedCodes.value.map((rowCode) => ({ code: rowCode, name: labelOf(rowCode) })),
)
const substituteRows = computed(() =>
  substituteCodes.value.map((rowCode) => ({ code: rowCode, name: labelOf(rowCode) })),
)

function addRelated(event: Event) {
  const next = (event.target as HTMLSelectElement).value
  ;(event.target as HTMLSelectElement).value = ''
  if (!next || relatedCodes.value.includes(next) || next === code.value) return
  if (substituteCodes.value.includes(next)) {
    notify('대체상품으로 이미 지정된 코드입니다.')
    return
  }
  if (relatedCodes.value.length >= 12) {
    notify('관련상품은 최대 12개까지입니다.')
    return
  }
  relatedCodes.value = [...relatedCodes.value, next]
}

function removeRelated(target: string) {
  relatedCodes.value = relatedCodes.value.filter((rowCode) => rowCode !== target)
}

function addSubstitute(event: Event) {
  const next = (event.target as HTMLSelectElement).value
  ;(event.target as HTMLSelectElement).value = ''
  if (!next || substituteCodes.value.includes(next)) return
  if (relatedCodes.value.includes(next)) {
    notify('관련상품으로 이미 지정된 코드입니다.')
    return
  }
  if (next === code.value) return
  if (substituteCodes.value.length >= 8) {
    notify('대체상품은 최대 8개까지입니다.')
    return
  }
  substituteCodes.value = [...substituteCodes.value, next]
}

function removeSubstitute(target: string) {
  substituteCodes.value = substituteCodes.value.filter((item) => item !== target)
}

async function loadRelatedCandidates() {
  try {
    const result = await fetchAdminProducts({ status: 'SELLING' })
    relatedCandidates.value = result.products
      .filter((row) => row.code !== code.value)
      .slice(0, 200)
      .map((row) => ({ code: row.code, name: row.name }))
  } catch {
    relatedCandidates.value = []
  }
}

function onSheetStatus(status: 'SELLING' | 'SOLDOUT' | 'HIDDEN') {
  void applySaleStatus(status)
}

async function applySaleStatus(next: 'SELLING' | 'SOLDOUT' | 'HIDDEN') {
  const current = product.value?.status
  if (!current || next === current || saving.value) return
  const ok = await confirmDialog({
    title: '판매 상태 변경',
    message: `판매 상태를 '${MALL_PRODUCT_STATUS_LABEL[next]}'으로 바꿀까요?`,
    confirmLabel: '변경',
    tone: 'primary',
  })
  if (!ok) return
  saving.value = true
  try {
    const { product: updated, message } = await setAdminProductStatus(code.value, next)
    product.value = updated
    notify(message || '판매 상태를 바꿨습니다.')
    await load()
  } catch (error) {
    notify(error instanceof Error ? error.message : '판매 상태 변경에 실패했습니다.')
  } finally {
    saving.value = false
  }
}

function applyRejectTemplate(tpl: string) {
  const next = rejectReason.value.trim() ? `${rejectReason.value.trim()}\n${tpl}` : tpl
  rejectReason.value = next.slice(0, 255)
}

function pulsePreviewTab(mode: ProductPreviewMode) {
  previewTabPulse.value = mode
  window.clearTimeout(previewTabPulseTimer)
  previewTabPulseTimer = window.setTimeout(() => {
    previewTabPulse.value = ''
  }, 1200)
}

const currentSurfaceDef = computed(() => surfaceDef(editSurface.value))
const surfaceDoneMap = computed(() => {
  const done = sectionDoneMap(form)
  const map = {} as Record<ProductEditSurface, boolean>
  for (const item of PRODUCT_EDIT_SURFACES) {
    map[item.id] = item.sections.every((id) => done[id])
  }
  return map
})

function setWorkMode(mode: 'wizard' | 'editor') {
  workMode.value = mode
  if (mode === 'editor') {
    editSurface.value = 'product'
    return
  }
  wizardRef.value?.resetFromForm(true)
}

function goSurface(surface: ProductEditSurface) {
  workMode.value = 'editor'
  const changed = editSurface.value !== surface
  editSurface.value = surface
  previewZone.value = ''
  if (surface === 'product' && previewMode.value !== 'card' && previewMode.value !== 'detail') {
    previewMode.value = 'card'
  }
  const main = dialogEl.value?.querySelector('.spform__main') as HTMLElement | null
  const side = dialogEl.value?.querySelector('.spform__side') as HTMLElement | null
  main?.scrollTo({ top: 0, behavior: 'auto' })
  side?.scrollTo({ top: 0, behavior: 'auto' })
  if (!changed) return
  const first = surfaceDef(surface).sections[0]
  if (!first) return
  void scrollWhenReady(
    () => document.getElementById(first),
    { behavior: 'auto', block: 'start', offsetTop: 16, container: main },
  )
}

function onSurfaceChange(surface: ProductEditSurface) {
  editSurface.value = surface
}

function onPreviewModeChange(mode: ProductPreviewMode) {
  if (editSurface.value === 'product') setPreviewMode(mode)
}

function setPreviewMode(mode: ProductPreviewMode) {
  previewMode.value = mode
  previewZone.value = previewZoneVisibleOn(previewZone.value, editSurface.value, mode)
}

function applyPreviewHighlight(zone: ProductPreviewZone | '') {
  const modeHint = previewModeForZone(zone)
  if (modeHint && editSurface.value === 'product' && previewMode.value !== modeHint) {
    previewMode.value = modeHint
    pulsePreviewTab(modeHint)
  } else if (modeHint && editSurface.value === 'product') {
    previewMode.value = modeHint
  }
  const visible = previewZoneVisibleOn(zone, editSurface.value, previewMode.value)
  previewZone.value = visible
  if (!visible) return

  const side = dialogEl.value?.querySelector('.spform__side') as HTMLElement | null
  if (!side) return

  if (editSurface.value === 'shipping') {
    void scrollWhenReady(
      () => side.querySelector('.spform__ship-preview') as HTMLElement | null,
      { behavior: 'auto', block: 'center', offsetTop: 120, offsetBottom: 24, container: side },
    )
    return
  }

  void scrollWhenReady(
    () => {
      const zoned = side.querySelector(`[data-zone="${visible}"]`) as HTMLElement | null
      if (zoned) return zoned
      return side.querySelector(
        previewMode.value === 'detail' ? '.spform__detail-embed' : '.spform__mall-card',
      ) as HTMLElement | null
    },
    {
      behavior: 'auto',
      block: 'center',
      offsetTop: 130,
      offsetBottom: 24,
      container: side,
    },
    480,
  )
}

function onPreviewZone(zone: ProductPreviewZone | '') {
  applyPreviewHighlight(zone)
}

function onCardEditZone(zone: ProductPreviewZone, fieldSuffix?: string) {
  const next = surfaceFromPreviewZone(zone)
  if (next) editSurface.value = next
  applyPreviewHighlight(zone)
  if (fieldSuffix) {
    const target = focusTargetFromPreviewZone(zone)
    if (target) editorRef.value?.focusSection(target.section, fieldSuffix)
    else editorRef.value?.focusByZone(zone)
  } else {
    editorRef.value?.focusByZone(zone)
  }
}

function onHotkey(event: KeyboardEvent) {
  if (!(event.ctrlKey || event.metaKey) || event.key.toLowerCase() !== 's') return
  event.preventDefault()
  void onSave({ skipConfirm: true })
}

function onWindowHotkey(event: KeyboardEvent) {
  onHotkey(event)
}

async function ensureRequestedQueue() {
  let codes = loadRequestedProductQueue()
  if (!codes.length || !codes.includes(code.value)) {
    try {
      const result = await fetchAdminProducts({ status: 'REQUESTED' })
      codes = result.products.map((row) => row.code)
      if (codes.length) saveRequestedProductQueue(codes)
    } catch {
      codes = codes.length ? codes : []
    }
  }
  queueCodes.value = codes
}

function onEsc() {
  if (saving.value || screenLock.value) return
  if (historyOpen.value) {
    historyOpen.value = false
    return
  }
  void onClose()
}

watch(historyOpen, (open) => {
  if (!open) return
  void nextTick(() => historyEl.value?.focus())
})

async function loadProduct() {
  historyOpen.value = false
  loading.value = true
  editSurface.value = 'product'
  previewMode.value = 'card'
  previewZone.value = ''
  try {
    const detail = await fetchAdminProduct(code.value)
    product.value = detail
    hydrateProductForm(form, detail)
    adminMemo.value = detail.adminMemo || ''
    relatedCodes.value = [...(detail.relatedCodes || [])]
    substituteCodes.value = [...(detail.substituteCodes || [])]
    rejectReason.value = detail.status === 'REJECTED' ? detail.rejectReason : ''
    markFormClean()
    workMode.value = 'wizard'
    wizardSeed.value = `${code.value}-${Date.now()}`
    void nextTick(() => wizardRef.value?.resetFromForm(true))
    void loadRelatedCandidates()
    if (detail.status === 'REQUESTED') {
      await ensureRequestedQueue()
    } else {
      queueCodes.value = []
    }
  } catch (error) {
    notify(error instanceof Error ? error.message : '상품을 불러오지 못했습니다.')
    router.replace('/admin/products')
  } finally {
    loading.value = false
    requestAnimationFrame(() => dialogEl.value?.focus())
  }
}

watch(code, () => {
  void loadProduct()
}, { immediate: true })

const showQueueNav = computed(
  () => product.value?.status === 'REQUESTED' && queueCodes.value.length > 1,
)
const queueIndex = computed(() => queueCodes.value.indexOf(code.value))
const prevCode = computed(() =>
  queueIndex.value > 0 ? queueCodes.value[queueIndex.value - 1] : '',
)
const nextCode = computed(() =>
  queueIndex.value >= 0 && queueIndex.value < queueCodes.value.length - 1
    ? queueCodes.value[queueIndex.value + 1]
    : '',
)

function goQueue(target: string) {
  if (!target || target === code.value || saving.value) return
  router.push(`/admin/products/${target}`)
}

function onProblemJump() {
  workMode.value = 'editor'
  void nextTick(() => editorRef.value?.focusFirstIncomplete())
}

function scrollToCheck(section: string) {
  const next = surfaceFromSection(section)
  if (next) editSurface.value = next
  editorRef.value?.focusSection(section)
}

const logs = computed(() => product.value?.logs ?? [])
const reviewLogs = computed(() => logs.value.filter((log) => REVIEW_ACTIONS.has(log.action)))
const otherLogs = computed(() => logs.value.filter((log) => !REVIEW_ACTIONS.has(log.action)))
const requestCount = computed(() => {
  const fromLogs = logs.value.filter((log) => log.action === 'REQUEST').length
  return Math.max(fromLogs, product.value?.requestCount ?? 0)
})

function logLabel(log: { action: string }, index: number): string {
  if (log.action !== 'REQUEST') return LOG_LABEL[log.action] || log.action
  const total = reviewLogs.value.filter((item) => item.action === 'REQUEST').length
  if (total <= 1) return '검수 요청'
  const requestOrder = reviewLogs.value
    .slice(0, index + 1)
    .filter((item) => item.action === 'REQUEST').length
  return `${total - requestOrder + 1}차 검수 요청`
}

const checklist = computed(() => productChecklist(form))
const checklistOk = computed(() => checklist.value.filter((rule) => rule.ok).length)
const checklistPct = computed(() =>
  checklist.value.length ? Math.round((checklistOk.value / checklist.value.length) * 100) : 0,
)
const hardIssues = computed(() => productIssues(form))
const firstFailedCheck = computed(() => checklist.value.find((rule) => !rule.ok) || null)

const shippingFeeLabel = computed(() => formatShippingChargeLabel(form))
const returnFeeLabel = computed(() => {
  const fee = Math.max(0, Number(storeShipping.value.returnFee) || 0)
  return fee > 0 ? `${fee.toLocaleString('ko-KR')}원` : '무료'
})
const { sameDayCutoffText, loadSameDayCutoffSnippet } = useSameDayCutoffText(
  () => storeShipping.value.cutoff,
)
const policyLines = computed(() =>
  String(storeShipping.value.returnPolicy || '')
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean),
)

const problems = computed(() => productProblems(form))
const firstProblem = computed(() => problems.value[0] ?? '')
const canReview = computed(() => product.value?.status === 'REQUESTED')
const canApprove = computed(() => canReview.value && hardIssues.value.length === 0)

const statusTone = computed(() =>
  product.value ? STATUS_TONE[product.value.status] ?? 'sui-badge--gray' : 'sui-badge--gray',
)

const previewProduct = computed(() =>
  toPreviewProduct(form, {
    code: code.value,
    storeName: product.value?.storeName ?? '',
    storeCutoff: storeShipping.value.cutoff,
    storeReturnFee: storeShipping.value.returnFee,
    storeReturnPolicy: storeShipping.value.returnPolicy,
  }),
)

async function onClose() {
  if (saving.value || screenLock.value) return
  if (dirty.value) {
    const ok = await confirmDialog({
      title: '작성 내용 확인',
      message: '저장하지 않은 상품 변경 내용이 있습니다. 닫을까요?',
      confirmLabel: '닫기',
      tone: 'danger',
    })
    if (!ok) return
  }
  router.push('/admin/products')
}

/** 저장은 상태를 건드리지 않는다. 판매로 올리는 건 승인 버튼이 한다. */
async function persist(): Promise<ServerMallProduct | null> {
  const status = product.value?.status ?? 'REQUESTED'
  const payload = {
    ...toProductPayload(form, status),
    adminMemo: adminMemo.value.trim(),
  }
  await saveAdminProduct(code.value, payload)
  const withRelated = await saveAdminProductRelated(code.value, {
    relatedCodes: relatedCodes.value,
    substituteCodes: substituteCodes.value,
  })
  product.value = withRelated
  adminMemo.value = withRelated.adminMemo || ''
  relatedCodes.value = [...(withRelated.relatedCodes || [])]
  substituteCodes.value = [...(withRelated.substituteCodes || [])]
  markFormClean()
  return withRelated
}

async function onSave(options: { skipConfirm?: boolean } = {}) {
  if (saving.value) return
  if (!options.skipConfirm) {
    const ok = await confirmDialog({
      title: '상품 수정 저장',
      message: '수정 내용을 저장할까요?',
      confirmLabel: '저장',
      tone: 'primary',
    })
    if (!ok) return
  }
  saving.value = true

  try {
    await persist()
    notify('수정 내용을 저장했습니다.')
  } catch (error) {
    notify(error instanceof Error ? error.message : '저장에 실패했습니다.')
  } finally {
    saving.value = false
  }
}

async function onApprove() {
  if (saving.value) return

  if (!canApprove.value) {
    notify(firstProblem.value)
    editorRef.value?.focusFirstIncomplete()
    return
  }
  const ok = await confirmDialog({
    title: '상품 판매 승인',
    message: '이 상품을 판매 승인할까요? 함우리몰에 바로 노출됩니다.',
    confirmLabel: '승인',
    tone: 'primary',
  })
  if (!ok) return

  saving.value = true
  screenLock.value = true
  screenLockText.value = '저장하고 올리는 중입니다'
  historyOpen.value = false

  try {
    await persist()
    const { product: approved, message } = await approveAdminProduct(code.value)
    product.value = approved
    notify(message || '판매 승인했습니다.')
    await load()
    router.push('/admin/products')
  } catch (error) {
    notify(error instanceof Error ? error.message : '승인에 실패했습니다.')
    saving.value = false
    screenLock.value = false
  }
}

async function onReject() {
  if (saving.value) return

  const reason = rejectReason.value.trim()

  if (!reason) {
    notify('반려 사유를 적어 주세요.')
    return
  }
  const ok = await confirmDialog({
    title: '상품 반려',
    message: '이 상품을 반려할까요? 사유가 판매업체에 전달됩니다.',
    confirmLabel: '반려',
    tone: 'danger',
  })
  if (!ok) return

  saving.value = true

  try {
    product.value = await rejectAdminProduct(code.value, reason)
    notify('반려했습니다. 사유가 판매업체에 전달됩니다.')
    await load()
    router.push('/admin/products')
  } catch (error) {
    notify(error instanceof Error ? error.message : '반려에 실패했습니다.')
  } finally {
    saving.value = false
  }
}

function formatDateTime(value?: string | null): string {
  if (!value) return '-'
  const date = new Date(value)
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(
    date.getDate(),
  ).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

onMounted(() => {
  document.body.style.overflow = 'hidden'
  window.addEventListener('keydown', onWindowHotkey)
  void loadSameDayCutoffSnippet()
})

onUnmounted(() => {
  document.body.style.overflow = ''
  window.removeEventListener('keydown', onWindowHotkey)
  window.clearTimeout(previewTabPulseTimer)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "spform aedit-modal",
    role: "presentation",
    onKeydown: [
      _withKeys(_withModifiers(onEsc, ["prevent"]), ["esc"]),
      onHotkey
    ]
  }, [
    _createElementVNode("div", {
      class: "spform__backdrop",
      onClick: onEsc
    }),
    _createElementVNode("div", {
      ref_key: "dialogEl",
      ref: dialogEl,
      class: "spform__dialog",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": titleId,
      tabindex: "-1"
    }, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", { id: titleId }, "상품 검수"),
            _createElementVNode("div", _hoisted_5, [
              (code.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(AppIcon, {
                      icon: "mdi-barcode",
                      size: 14
                    }),
                    _createTextVNode(" " + _toDisplayString(code.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (product.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(["sui-badge", statusTone.value])
                  }, _toDisplayString(product.value.status === 'REQUESTED' ? '검수요청' : _unref(MALL_PRODUCT_STATUS_LABEL)[product.value.status]), 3))
                : _createCommentVNode("", true),
              (product.value?.storeName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createVNode(AppIcon, {
                      icon: "mdi-storefront-outline",
                      size: 14
                    }),
                    _createTextVNode(" " + _toDisplayString(product.value.storeName), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (product.value && !loading.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "aedit-modal__history-btn",
                  "data-tour": "admin-product-history",
                  disabled: saving.value || screenLock.value,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (historyOpen.value = true))
                }, [
                  _cache[15] || (_cache[15] = _createTextVNode(" 이력 ", -1)),
                  (logs.value.length)
                    ? (_openBlock(), _createElementBlock("em", _hoisted_10, _toDisplayString(logs.value.length), 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_9))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "spform__close",
              "aria-label": "닫기",
              disabled: saving.value || screenLock.value,
              onClick: onClose
            }, [
              _createVNode(AppIcon, {
                icon: "mdi-close",
                size: 20
              })
            ], 8, _hoisted_11)
          ])
        ])
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(AppIcon, {
              icon: "mdi-loading",
              size: 28
            }),
            _cache[16] || (_cache[16] = _createElementVNode("p", null, "상품을 불러오는 중입니다…", -1))
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", {
              class: _normalizeClass(["spform__body spform__body--register", { 'spform__body--sale': form.mallKind === 'SALE' }])
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(ProductRegisterSheet, {
                  form: form,
                  tone: "admin",
                  "store-name": product.value?.storeName || '',
                  categories: [..._unref(SELLER_CATEGORIES)],
                  uploader: _unref(uploadAdminImages),
                  "store-shipping": storeShipping.value,
                  "store-shipping-readonly": "",
                  "stock-locked": stockLocked.value,
                  "sale-status": product.value?.status || '',
                  "can-edit-status": canToggleSaleStatus.value,
                  "is-new": false,
                  onNotify: _unref(notify),
                  onOpenStockHistory: _cache[1] || (_cache[1] = ($event: any) => (stockHistoryOpen.value = true)),
                  onUpdateStatus: onSheetStatus
                }, null, 8, ["form", "store-name", "categories", "uploader", "store-shipping", "stock-locked", "sale-status", "can-edit-status", "onNotify"]),
                (showQueueNav.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, [
                        _cache[17] || (_cache[17] = _createTextVNode(" 검수요청 ", -1)),
                        (queueIndex.value >= 0)
                          ? (_openBlock(), _createElementBlock("em", _hoisted_16, _toDisplayString(queueIndex.value + 1) + " / " + _toDisplayString(queueCodes.value.length), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "sui-btn sui-btn--ghost sui-btn--sm",
                          disabled: !prevCode.value || saving.value,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (goQueue(prevCode.value)))
                        }, [
                          _createVNode(AppIcon, {
                            icon: "mdi-chevron-left",
                            size: 16
                          }),
                          _cache[18] || (_cache[18] = _createTextVNode(" 이전 ", -1))
                        ], 8, _hoisted_18),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sui-btn sui-btn--ghost sui-btn--sm",
                          disabled: !nextCode.value || saving.value,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (goQueue(nextCode.value)))
                        }, [
                          _cache[19] || (_cache[19] = _createTextVNode(" 다음 ", -1)),
                          _createVNode(AppIcon, {
                            icon: "mdi-chevron-right",
                            size: 16
                          })
                        ], 8, _hoisted_19)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[20] || (_cache[20] = _createElementVNode("h3", null, "내부 메모", -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("p", { class: "aedit-modal__ops-hint" }, "판매업체·구매자에게 보이지 않습니다.", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((adminMemo).value = $event)),
                      class: "sui-input",
                      rows: "3",
                      maxlength: "1000",
                      placeholder: "예: 원가 협의 중 · 패키지 변경 예정"
                    }, null, 512), [
                      [_vModelText, adminMemo.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[24] || (_cache[24] = _createElementVNode("h3", null, "관련 · 대체 상품", -1)),
                    _cache[25] || (_cache[25] = _createElementVNode("p", { class: "aedit-modal__ops-hint" }, " 상세 「관련상품」·품절 시 「대체상품」에 쓰입니다. 비우면 같은 분류 자동 추천입니다. ", -1)),
                    _cache[26] || (_cache[26] = _createElementVNode("label", {
                      class: "aedit-modal__ops-label",
                      for: "related-pick"
                    }, "관련상품 추가", -1)),
                    _createElementVNode("select", {
                      id: "related-pick",
                      class: "sui-select",
                      value: '',
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (addRelated($event)))
                    }, [
                      _cache[22] || (_cache[22] = _createElementVNode("option", { value: "" }, "판매중 상품 선택", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedCandidates.value, (row) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: `rel-${row.code}`,
                          value: row.code,
                          disabled: relatedCodes.value.includes(row.code) || substituteCodes.value.includes(row.code)
                        }, _toDisplayString(row.name) + " (" + _toDisplayString(row.code) + ") ", 9, _hoisted_23))
                      }), 128))
                    ], 32),
                    (relatedCodes.value.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedRows.value, (row) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: `r-${row.code}`
                            }, [
                              _createElementVNode("span", null, [
                                _createTextVNode(_toDisplayString(row.name) + " ", 1),
                                _createElementVNode("em", null, _toDisplayString(row.code), 1)
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "sui-btn sui-btn--sm",
                                onClick: ($event: any) => (removeRelated(row.code))
                              }, " 제거 ", 8, _hoisted_25)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _cache[27] || (_cache[27] = _createElementVNode("label", {
                      class: "aedit-modal__ops-label",
                      for: "sub-pick"
                    }, "대체상품 추가", -1)),
                    _createElementVNode("select", {
                      id: "sub-pick",
                      class: "sui-select",
                      value: '',
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (addSubstitute($event)))
                    }, [
                      _cache[23] || (_cache[23] = _createElementVNode("option", { value: "" }, "판매중 상품 선택", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedCandidates.value, (row) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: `sub-${row.code}`,
                          value: row.code,
                          disabled: relatedCodes.value.includes(row.code) || substituteCodes.value.includes(row.code)
                        }, _toDisplayString(row.name) + " (" + _toDisplayString(row.code) + ") ", 9, _hoisted_26))
                      }), 128))
                    ], 32),
                    (substituteCodes.value.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(substituteRows.value, (row) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: `s-${row.code}`
                            }, [
                              _createElementVNode("span", null, [
                                _createTextVNode(_toDisplayString(row.name) + " ", 1),
                                _createElementVNode("em", null, _toDisplayString(row.code), 1)
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "sui-btn sui-btn--sm",
                                onClick: ($event: any) => (removeSubstitute(row.code))
                              }, " 제거 ", 8, _hoisted_28)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 2),
            _createElementVNode("footer", _hoisted_29, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--ghost spform__foot-cancel",
                disabled: saving.value,
                onClick: onClose
              }, " 취소 ", 8, _hoisted_30),
              _createElementVNode("div", _hoisted_31, [
                (firstProblem.value)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "spform__problem",
                      role: "button",
                      tabindex: "0",
                      onClick: onProblemJump,
                      onKeydown: _withKeys(_withModifiers(onProblemJump, ["prevent"]), ["enter"])
                    }, [
                      _createVNode(AppIcon, {
                        icon: "mdi-alert-outline",
                        size: 15
                      }),
                      _createTextVNode(" " + _toDisplayString(firstProblem.value), 1)
                    ], 40, _hoisted_32))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                  (canReview.value)
                    ? (_openBlock(), _createElementBlock("details", {
                        key: 0,
                        class: "aedit-modal__reject",
                        open: product.value?.status === 'REJECTED'
                      }, [
                        _createElementVNode("summary", null, [
                          _createVNode(AppIcon, {
                            icon: "mdi-close-circle-outline",
                            size: 16
                          }),
                          _cache[28] || (_cache[28] = _createElementVNode("span", null, "반려", -1))
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rejectTemplates), (tpl) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: tpl,
                                type: "button",
                                class: "aedit-modal__tpl",
                                onClick: ($event: any) => (applyRejectTemplate(tpl))
                              }, _toDisplayString(tpl.slice(0, 18)) + _toDisplayString(tpl.length > 18 ? '…' : ''), 9, _hoisted_37))
                            }), 128))
                          ]),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((rejectReason).value = $event)),
                            class: "sui-input",
                            rows: "3",
                            maxlength: "255",
                            placeholder: "어떤 점을 고쳐 다시 보내야 하는지 적어 주세요."
                          }, null, 512), [
                            [_vModelText, rejectReason.value]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "sui-btn aedit-modal__reject-btn",
                            disabled: saving.value,
                            onClick: onReject
                          }, [
                            _createVNode(AppIcon, {
                              icon: "mdi-alert-circle-outline",
                              size: 16
                            }),
                            _cache[29] || (_cache[29] = _createElementVNode("span", null, "반려하고 판매업체에 알리기", -1))
                          ], 8, _hoisted_38)
                        ])
                      ], 8, _hoisted_34))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "sui-btn",
                    disabled: saving.value,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (onSave()))
                  }, [
                    _createVNode(AppIcon, {
                      icon: "mdi-content-save-outline",
                      size: 16
                    }),
                    _createElementVNode("span", null, _toDisplayString(saving.value ? '저장 중…' : '저장'), 1)
                  ], 8, _hoisted_39),
                  (canReview.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "sui-btn sui-btn--primary",
                        disabled: saving.value || !canApprove.value,
                        onClick: onApprove
                      }, [
                        _createVNode(AppIcon, {
                          icon: saving.value ? 'mdi-loading' : 'mdi-check-decagram',
                          size: 16
                        }, null, 8, ["icon"]),
                        _createElementVNode("span", null, _toDisplayString(saving.value ? '저장 중…' : '저장하고 판매 승인'), 1)
                      ], 8, _hoisted_40))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 64))
    ], 512),
    (showPreview.value)
      ? (_openBlock(), _createBlock(SellerProductPreview, {
          key: 0,
          product: previewProduct.value,
          "active-zone": previewZone.value,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (showPreview.value = false)),
          onEditZone: onCardEditZone
        }, null, 8, ["product", "active-zone"]))
      : _createCommentVNode("", true),
    (stockHistoryOpen.value && code.value)
      ? (_openBlock(), _createBlock(ProductStockHistoryModal, {
          key: 1,
          "product-code": code.value,
          "product-name": form.name,
          audience: "admin",
          onClose: _cache[10] || (_cache[10] = ($event: any) => (stockHistoryOpen.value = false)),
          onUpdated: onStockLedgerUpdated
        }, null, 8, ["product-code", "product-name"]))
      : _createCommentVNode("", true),
    (historyOpen.value && product.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "aedit-hist",
          onKeydown: _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (historyOpen.value = false), ["stop","prevent"]), ["esc"]))
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "aedit-hist__catch",
            "aria-label": "검수 이력 닫기",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (historyOpen.value = false))
          }),
          _createElementVNode("div", {
            ref_key: "historyEl",
            ref: historyEl,
            class: "aedit-hist__panel",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": historyTitleId,
            tabindex: "-1"
          }, [
            _createElementVNode("header", _hoisted_41, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", { id: historyTitleId }, "검수 이력"),
                _createElementVNode("p", null, " 검수 요청 " + _toDisplayString(requestCount.value) + "회 · 최근 요청 " + _toDisplayString(formatDateTime(product.value.requestedAt)) + " · 최근 검수 " + _toDisplayString(product.value.reviewedAt
                  ? `${formatDateTime(product.value.reviewedAt)} · ${product.value.reviewer}`
                  : '없음'), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "aedit-hist__close",
                "aria-label": "검수 이력 닫기",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (historyOpen.value = false))
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 20
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              (product.value.requestNote)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createVNode(AppIcon, {
                      icon: "mdi-alert-circle-outline",
                      size: 20
                    }),
                    _createElementVNode("div", null, [
                      _cache[30] || (_cache[30] = _createElementVNode("strong", null, "현재 요청 메모", -1)),
                      _createElementVNode("p", null, _toDisplayString(product.value.requestNote), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (reviewLogs.value.length)
                ? (_openBlock(), _createElementBlock("ol", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviewLogs.value, (log, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `${log.at}-${index}`
                      }, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["aedit-modal__log-action", `is-${log.action.toLowerCase()}`])
                          }, _toDisplayString(logLabel(log, index)), 3),
                          _createElementVNode("time", null, _toDisplayString(formatDateTime(log.at)), 1)
                        ]),
                        _createElementVNode("p", _hoisted_46, _toDisplayString(log.role === 'ADMIN' ? '관리자' : '판매업체') + " " + _toDisplayString(log.actor), 1),
                        (log.memo)
                          ? (_openBlock(), _createElementBlock("pre", _hoisted_47, _toDisplayString(log.memo), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_48, "남긴 내용 없음"))
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_49, "아직 검수 요청·승인·반려 이력이 없습니다.")),
              (otherLogs.value.length)
                ? (_openBlock(), _createElementBlock("details", _hoisted_50, [
                    _createElementVNode("summary", null, "그 외 이력 " + _toDisplayString(otherLogs.value.length) + "건", 1),
                    _createElementVNode("ul", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherLogs.value, (log, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: `other-${log.at}-${index}`
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["aedit-modal__log-action", `is-${log.action.toLowerCase()}`])
                          }, _toDisplayString(LOG_LABEL[log.action] || log.action), 3),
                          _createElementVNode("span", null, _toDisplayString(log.role === 'ADMIN' ? '관리자' : '판매업체') + " " + _toDisplayString(log.actor), 1),
                          _createElementVNode("span", null, _toDisplayString(log.memo || '-'), 1),
                          _createElementVNode("time", null, _toDisplayString(formatDateTime(log.at)), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("footer", _hoisted_52, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--ghost",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (historyOpen.value = false))
              }, "닫기")
            ])
          ], 512)
        ], 32))
      : _createCommentVNode("", true),
    (screenLock.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
          _createElementVNode("span", _hoisted_54, [
            _createVNode(AppIcon, {
              icon: "mdi-loading",
              size: 36
            })
          ]),
          _createElementVNode("p", null, _toDisplayString(screenLockText.value), 1)
        ]))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}
}

})